import { ToastAction } from "@/Components/ui/toast";
import NotFound from "@/Modules/NotFound/NotFound";
import useBreakpoint from "@/hooks/use-breakpoint";
import { useToast } from "@/hooks/use-toast";
import { useSteps } from "@chakra-ui/react";
import { useEffect, useLayoutEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
   Details,
   FormValues,
   Item,
   OptionTypes,
} from "../../types/productTypes";
import { calculateTotalPrice } from "../../utils/calculateTotalPrice";
import PriceComponent from "./PriceComponent";
import SkeletonConfig from "./Skeleton/SkeletonConfig";
import StagePage from "./StagePage";
import { useDefaultValues } from "./hooks/useDefaultValues";
import { useFetchProduct } from "./hooks/useFetchProduct";
import HorizontalStepper from "./stepper/HorizontalStepper";
import { useAdminStore } from "@/store/useAdminStore";
import { useTranslation } from "@/hooks/use-translation";
type ConfiguratorDisplayProps = {
   currentProductName: string;
};

export type ChosenOptions = {
   chosenItem: Item | (Item | null)[];
   name: string;
   type: OptionTypes;
};

export type Data = {
   productName: string;
   totalPrice: number;
   details: Details | undefined;
   options: ChosenOptions[];
   imageNames: string[];
   wireframeImage: string;
};
export type CONSTANTSType = {
   [key: string]: string[];
};

export default function ConfiguratorDisplay({
   currentProductName,
}: ConfiguratorDisplayProps) {
   const navigate = useNavigate();
   const { isMobile } = useBreakpoint();
   const { product, isLoading } = useFetchProduct(currentProductName);

   const { toast } = useToast();
   const { methods, loaded } = useDefaultValues();
   const allValues = methods.watch();
   const adminStore = useAdminStore();
   const { localizePath } = useTranslation();
   useEffect(() => {
      adminStore.fetchLearnMore();
   }, []);
   const goNext = () => {
      toast({
         title: "By Selecting this option you will not be able to select next options ",
         description: "",
         action: (
            <ToastAction altText="Goto schedule to undo">Undo</ToastAction>
         ),
      });
      goToNext();
   };

   const { activeStep, goToPrevious, goToNext, setActiveStep } = useSteps({
      index: 0,
      count: product?.stages.length,
   });
   const totalPrice = calculateTotalPrice(
      allValues as FormValues,
      product?.stages,
      product?.initialPrice
   );

   useLayoutEffect(() => {
      window.scrollTo({
         top: 0,
         left: 0,
         behavior: "instant",
      });
   }, [product]);

   useLayoutEffect(() => {
      console.log("fallingProduct", product);
      if (!product) return;
      const currentStage = product.stages[activeStep];
      console.log("falling stage", currentStage);
      if (!currentStage.options) return;
      currentStage.options.forEach((option) => {
         const id = option.id?.toString();
         if (!id) return;
         console.log("fallValues", allValues);
         if (
            allValues[id] &&
            "selected" in allValues[id] &&
            !allValues[id].selected
         ) {
            console.log("fall", allValues[id].selectedItem);
            methods.setValue(id, {
               selectedItem: allValues[id].selectedItem,
               selected: true,
            });
         }
      });
      const nextStage =
         activeStep < product.stages.length && product.stages[activeStep + 1];
      if (nextStage) {
         nextStage.options?.forEach((option) => {
            const id = option.id?.toString();
            if (!id) return;

            if (
               allValues[id] &&
               "selected" in allValues[id] &&
               allValues[id].selected
            ) {
               methods.setValue(id, {
                  selectedItem: allValues[id].selectedItem,
                  selected: false,
               });
            }
         });
      }
   }, [activeStep, product, loaded]);

   const checkout = () => {
      const summaryIndex = product?.stages.findIndex(
         (stage) => stage.type === "summary"
      );
      setActiveStep(summaryIndex || 0);
   };

   const handlePrevious = () => {
      return activeStep === 0 ? navigate(localizePath("/")) : goToPrevious();
   };
   if (isLoading || product === undefined) {
      return <SkeletonConfig />;
   }

   if (!product) {
      return <NotFound />;
   }
   console.log("totalPrice", totalPrice);

   return (
      <div className={`flex w-screen ${isMobile ? "h-auto" : "h-95vh"}`}>
         <FormProvider {...methods}>
            <div
               className={`flex flex-col relative ${
                  isMobile ? "w-full" : "w-11/12"
               } h-full `}
            >
               <div
                  className={`flex relative h-full   ${
                     isMobile ? "flex-col-reverse pb-32" : "flex-row"
                  }  `}
               >
                  <StagePage
                     index={activeStep}
                     goToNext={goNext}
                     checkout={checkout}
                     product={product}
                     stage={product.stages[activeStep]}
                     nextStage={
                        activeStep < product.stages.length - 1
                           ? product.stages[activeStep + 1]
                           : null
                     }
                     productName={product.name}
                     productTitle={product.title}
                     priceComponent={
                        <PriceComponent
                           totalCurrentPrice={totalPrice}
                           offer={activeStep === product.stages.length - 1}
                           goToNext={goToNext}
                           goToPrevious={handlePrevious}
                        />
                     }
                     stepper={
                        <HorizontalStepper
                           stages={product.stages}
                           index={activeStep}
                           setActiveStep={setActiveStep}
                        />
                     }
                  ></StagePage>
               </div>
            </div>
         </FormProvider>
      </div>
   );
}
